import { Component, OnInit, QueryList, ViewChildren } from '@angular/core';
import { User, UserAddress } from 'src/app/_models';
import { UserAddressComponent } from '../user-edit/user-address/user-address.component';
import { UserService,  UtilsService } from 'src/app/_services';
import { ApplicationStateService } from 'src/app/_services/application-state.service';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ZipCodeValidator } from 'src/app/_validators/zipcode.validator';
import { TranslateService } from '@ngx-translate/core';


@Component({
  selector: 'app-user-addresses',
  templateUrl: './user-addresses.component.html',
  styleUrls: ['./user-addresses.component.css']
})



export class UserAddressesComponent implements OnInit {
  
  public billingAddress : UserAddress;
  public userAdresses : UserAddress[];
  public billingAddressEditForm : FormGroup;
  
  @ViewChildren(UserAddressComponent) addresses: QueryList<UserAddressComponent>

  

  constructor(
    public apps : ApplicationStateService,
    private users : UserService,
    private formBuilder: FormBuilder,
    private utils : UtilsService,
    private zipCodeValidator: ZipCodeValidator,
    public translate : TranslateService
  ) {

  }

  get f() { 
    return this.billingAddressEditForm.controls; 
  }

  ngOnInit() {

    this.users.editingUser.subscribe(user => {
      this.billingAddress = user.user_addresses.find( address => {
        return address.address_type == 1;
      })

      this.userAdresses = user.user_addresses.filter( address => {
        return address.address_type == 2;
      });

      //Usuarios registrados sin dirección de facturación. No debería ocurrir salvo en entorno de pruebas o fallo grave del registro
      if (! this.billingAddress  ){
        this.billingAddress = user.user_addresses[0];
      }
    });


    this.billingAddressEditForm = this.formBuilder.group({
      name: [this.billingAddress.address_name,  Validators.required],
      street: [this.billingAddress.address_street,  Validators.required],
      number: [this.billingAddress.address_number,  Validators.required],
      floor: [this.billingAddress.address_floor],
      door: [this.billingAddress.address_door],
      stair: [this.billingAddress.address_stair],
      zipCode: [this.billingAddress.zipcode,  Validators.required, this.zipCodeValidator.checkZipCode.bind(this.zipCodeValidator ) ],
      city: [this.billingAddress.city,  Validators.required],
      province: [this.billingAddress.province,  Validators.required],
      addressType: [this.billingAddress.isprimary],
      observ: [this.billingAddress.observ],
      recid: [this.billingAddress.recid],
    });

  }

  canDeactivate() : boolean {
    let can : boolean = true;

    this.addresses.forEach( address => {
      can = can && address.canDeactivate();
    });

    return can ;
  }

  onSubmit(){

    if (this. billingAddressEditForm.invalid){
      return;
    }

    this.billingAddress.address_name = this.f.name.value;
    this.billingAddress.address_street = this.f.street.value;
    this.billingAddress.address_door = this.f.door.value;
    this.billingAddress.address_floor= this.f.floor.value;
    this.billingAddress.address_number= this.f.number.value;
    this.billingAddress.address_stair =  this.f.stair.value;
    this.billingAddress.address_type = 1
    this.billingAddress.city = this.f.city.value;
    this.billingAddress.province = this.f.province.value;
    this.billingAddress.observ = this.f.observ.value;
    this.billingAddress.recid = this.f.recid.value;
    
    if (this.f.addressType.value) this.billingAddress.isprimary = 1;
    else this.billingAddress.isprimary = 0;

    this.billingAddress.zipcode = this.f.zipCode.value ;
    
    this.users.updateAddress(this.billingAddress).subscribe();

  }


  setZipCode (){
    this.utils.getProvince(this.f.zipCode.value).subscribe(province => this.f.province.setValue(province));
  }

  getNotification(event:any){
    this.users.editingUser.subscribe(user => {
      this.userAdresses = user.user_addresses.filter( address => {
        return address.address_type == 2;
      }); 
    });
  }

}
